import DayPicker from 'lib/DatePicker/DayPicker';
import { DATE_FORMAT } from 'modules/api/constants';
import { isValid } from 'date-fns';
import { FilterDateProps } from './FilterDate.types';

const normalizeDate = (date?: Date): Date | undefined => {
  if (!date) return undefined;

  return isValid(date) ? date : undefined;
};

const FilterDate: React.FC<FilterDateProps> = ({
  changeFilters,
  keyName,
  selectedDate,
  placeholder = 'Search by timeframe',
  isDisabled = false,
  disabledDays,
}) => {
  const handleDateChange = (value: Date | null): void => {
    changeFilters({ [keyName]: value ?? undefined });
  };

  const normalizedSelectedDate = normalizeDate(selectedDate);

  return (
    <DayPicker
      dataTestId="filter-date-picker"
      onDayChange={handleDateChange}
      placeholder={placeholder}
      format={DATE_FORMAT}
      selectedDay={normalizedSelectedDate}
      isDisabled={isDisabled}
      isClearable
      disabledDays={disabledDays}
    />
  );
};

export default FilterDate;
